import { BundleInfo } from './get-bundle-info';

export function getElementName({ WebComponent }: Pick<BundleInfo, 'WebComponent'>) {
    return WebComponent.replace(/-[^-]+$/, '');
}
